module.exports = __webpack_public_path__ + "img/job-special-risk.ea7b71ef.svg";